export const BLOG_POSTS = [
  {
    blogId: 1,
    blogTitle: "5 Cliches About Technology You Should Avoid",
    blogURL:
      "https://cdn.pixabay.com/photo/2017/12/26/21/19/circle-3041437_1280.jpg",
    blogCategory: "Technology",
    blogAuthor: "Marvin Meyer",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2016/08/27/11/16/contractor-1623889_960_720.jpg",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },

  {
    blogId: 2,
    blogTitle: "The Ultimate Glossary of Terms About Technology",
    blogURL:
      "https://cdn.pixabay.com/photo/2012/10/29/15/36/ball-63527_1280.jpg",
    blogCategory: "Technology",
    blogAuthor: "Timothy Hales Bennett",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2014/03/25/16/54/user-297566_960_720.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 10,
  },

  {
    blogId: 3,
    blogTitle: "What Will Natural Beauty Be Like in 100 Years?",
    blogURL:
      "https://cdn.pixabay.com/photo/2018/01/12/14/24/night-3078326_1280.jpg",
    blogCategory: "Nature",
    blogAuthor: "Timothy Hales Bennett",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2014/03/25/16/54/user-297566_960_720.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 10,
  },
  {
    blogId: 4,
    blogTitle: "Natural Beauty Explained in Instagram Photos",
    blogURL:
      "https://cdn.pixabay.com/photo/2020/02/24/06/33/crescent-4875339_1280.jpg",
    blogCategory: "Nature",
    blogAuthor: "Marvin Meyer",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2016/08/27/11/16/contractor-1623889_960_720.jpg",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },
  {
    blogId: 5,
    blogTitle: "It's nice to just embrace the natural beauty within you.",
    blogURL:
      "https://cdn.pixabay.com/photo/2020/02/06/16/00/forest-4824761_1280.png",
    blogCategory: "Nature",
    blogAuthor: "John Thomas",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2017/06/30/10/14/social-media-2457842__340.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },
  {
    blogId: 6,
    blogTitle: "8 Go-To Resources About Travel",
    blogURL:
      "https://cdn.pixabay.com/photo/2021/01/05/06/40/boat-5889919_1280.png",
    blogCategory: "Travel",
    blogAuthor: "John Thomas",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2017/06/30/10/14/social-media-2457842__340.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },

  {
    blogId: 7,
    blogTitle: "Jobs fill your pockets, adventures fill your soul.",
    blogURL:
      "https://cdn.pixabay.com/photo/2022/05/22/07/39/climb-mountains-7212848_1280.jpg",
    blogCategory: "Travel",
    blogAuthor: "Percy Vere.",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2013/07/12/15/24/woman-149861__340.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },
  {
    blogId: 8,
    blogTitle:
      "A recipe has no soul. You as the cook must bring soul to the recipe.",
    blogURL:
      "https://images.unsplash.com/photo-1601315379734-425a469078de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZvbyUyMHJlY2lwZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
    blogCategory: "Food",
    blogAuthor: "Percy Vere.",
    UserAvatarURL:
      "https://cdn.pixabay.com/photo/2013/07/12/15/24/woman-149861__340.png",
    timeStamp: new Date().toISOString().slice(0, 10),
    Bloglength: 6,
  },
];
